import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from 'axios';
import security from '../services/security';
import type { UsuarioResponse } from '../types';

export const useAuthStore = defineStore('auth', () => {
    const token = ref("");
    const refresh_token = ref("");
    const varToken = ref("");
    const logedUser = ref("");
    const userParams = ref<UsuarioResponse | null>(null);

    async function login(user: string, pass: string) {
        const comsumerKey = import.meta.env.VITE_CONSUMER_KEY;
        const comsumerSecret = import.meta.env.VITE_CONSUMER_SECRET;
        const username = user;
        const password = pass;
        varToken.value = btoa(comsumerKey + ':' + comsumerSecret);

        try {
            const { data } = await axios.post('/token/oauth2/token', {
                grant_type: 'password',
                username: username,
                password: password
            }, {
                headers: {
                    'Authorization': 'Basic ' + varToken.value,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            token.value = data.access_token;
            refresh_token.value = data.refresh_token;
            logedUser.value = username.toLowerCase();

            // Llamar a la API y guardar los parámetros del usuario
            try {
                const response = await security.getDatosUsuario(logedUser.value);
                const responseData = response.data;
                // Reparar roles si es string tipo '["WEBUSER"]'
                if (responseData?.Usuario?.roles && typeof responseData.Usuario.roles === 'string') {
                    try {
                        const parsed = JSON.parse(responseData.Usuario.roles);
                        if (Array.isArray(parsed)) {
                            (responseData.Usuario.roles as any) = parsed;
                        }
                    } catch (err) {
                        // Si no se puede parsear, dejar el valor original
                    }
                }
                userParams.value = responseData;
            } catch (e) {
                userParams.value = null;
            }

            // Validar estado del usuario
            if (!userParams.value || userParams.value.Usuario?.estado !== 1) {
                return false;
            }

            return token.value != "" ? true : false;
        } catch (err) {
            console.log(err);
            const error = err as { response?: { data?: { error?: string, error_description?: string } } };
            if (error.response?.data?.error === 'invalid_grant' && error.response?.data?.error_description === 'Persisted access token data not found') {
                token.value = "";
                refresh_token.value = "";
                logedUser.value = "";
                userParams.value = null;
            }
            return false;
        }
    }

    async function refreshToken() {
        try {
            const { data } = await axios.post('/token/oauth2/token', {
                grant_type: 'refresh_token',
                refresh_token: refresh_token.value
            }, {
                headers: {
                    'Authorization': 'Basic ' + varToken.value,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            token.value = data.access_token;
            refresh_token.value = data.refresh_token;
            return token.value != "" ? true : false;
        } catch (err: any) {
            if (err.code === "ERR_BAD_REQUEST") {
                token.value = "";
                refresh_token.value = "";
                logedUser.value = "error";
                userParams.value = null;
            }
            return false;
        }
    }



    /**
     * Hidrata la sesión desde un origen externo (ej: alerce-mobile via postMessage).
     * No hace llamada al servidor de tokens; usa el token ya obtenido.
     */
    async function setSession(accessToken: string, refreshTokenVal: string, user: string): Promise<boolean> {
        token.value = accessToken;
        refresh_token.value = refreshTokenVal;
        logedUser.value = user.toLowerCase();
        // Recalcular varToken para poder hacer refresh en el futuro
        varToken.value = btoa(
            import.meta.env.VITE_CONSUMER_KEY + ':' + import.meta.env.VITE_CONSUMER_SECRET
        );
        try {
            const response = await security.getDatosUsuario(logedUser.value);
            const responseData = response.data;
            if (responseData?.Usuario?.roles && typeof responseData.Usuario.roles === 'string') {
                try {
                    const parsed = JSON.parse(responseData.Usuario.roles);
                    if (Array.isArray(parsed)) (responseData.Usuario.roles as any) = parsed;
                } catch (_) { /* JSON.parse falló, se deja el valor original */ }
            }
            userParams.value = responseData;
            return !!token.value;
        } catch {
            userParams.value = null;
            return !!token.value;
        }
    }

    return {
        login,
        setSession,
        token,
        refreshToken,
        logedUser,
        userParams
    };
});